import{LitElement,html,css,paths,unsafeHTML,classMap,utils,}from '@hh/global.js'
class HHStickyAtc extends LitElement{static properties={sectionId:{type:String,attribute:'section-id'},title:{type:String,},options:{type:Array,},_open:{state:!0,},_show:{state:!0,},currentVariant:{type:Object,},defaultVariant:{type:String,attribute:'default-variant',},defaultMedia:{type:Object,attribute:'default-media',},hasOnlyDefaultVariant:{type:Boolean,attribute:'has-only-default-variant',},hideOpacity:{type:Boolean,reflect:!0,},buttonContent:{type:String,attribute:'button-content'}}
constructor(){super()
this._externalButtonContent=!1}
connectedCallback(){super.connectedCallback()
this.scrolled=!1
this.currentVariant=JSON.parse(utils.decode(this.defaultVariant))
this.sizes=this.options[0].values
this.mainVariantPicker=document.querySelector('hh-variant-picker')
this.mainProductForm=document.querySelector('hh-product-form')
this.headerHeight=null
this._externalButtonContent=!!this.buttonContent
this.mainVariantPicker?.addEventListener('variant:change',this.onMainVariantChange.bind(this))
this.mainProductForm.addEventListener('productAdded',this.onSubmitSuccess.bind(this))
window.addEventListener('keydown',this.onEscapeKeydown.bind(this))
document.body.addEventListener('click',this.onBodyClick.bind(this))
window.addEventListener('scroll',this.handleScroll.bind(this))
this.initObservers()
this.setContent()}
disconnectedCallback(){super.disconnectedCallback()
this.mainVariantPicker?.removeEventListener('variant:change',this.onMainVariantChange)
this.mainProductForm.removeEventListener('productAdded',this.onSubmitSuccess)
window.removeEventListener('keydown',this.onEscapeKeydown)
window.removeEventListener('scroll',this.handleScroll)
document.body.removeEventListener('click',this.handleBodyClick)
this.observer?.unobserve(document.querySelector('hh-product-form .product-form__buttons'))
this.observer?.disconnect()
this.footerObserver?.unobserve(document.querySelector('footer'))
this.footerObserver?.disconnect()}
initObservers(){this.footerObserver=new IntersectionObserver(this.onFooterIntersection.bind(this),{threshold:0})
this.footerObserver.observe(document.querySelector('footer'))}
onVariantDropdownClick(){this._open=!this._open}
onFooterIntersection([entry]){const{isIntersecting}=entry
this.hideOpacity=isIntersecting}
onAddToCartClick(e){e.preventDefault()
const{target}=e
if(this.currentVariant.available){this.mainProductForm.dispatchEvent(new CustomEvent('addToCart',{bubbles:!0}))
target.setAttribute('disabled',!0)
target.classList.add('loading')}else{BIS.popup.show({variantId:this.currentVariant?.id})}}
openCart(){document.body.classList.add('mini-cart-is-visible')
setTimeout(()=>{document.querySelector('html').classList.add('overflow-hidden')
document.body.classList.add('mini-cart-is-active')
document.querySelector('.js-mega-menu-overlay').classList.add('active')})}
onSubmitSuccess(){if(this.atcButton.hasAttribute('disabled')){this.atcButton.removeAttribute('disabled')
this.atcButton.classList.remove('loading')}
this.openCart()}
onMainVariantChange(e){this.currentVariant=e.detail.variant
this.observer?.unobserve(document.querySelector('hh-product-form .product-form__buttons'))
this.observer?.disconnect()
setTimeout(()=>{this.mainProductForm=document.querySelector('hh-product-form')
this.mainVariantPicker=document.querySelector('hh-variant-picker')
this.mainVariantPicker?.addEventListener('variant:change',this.onMainVariantChange.bind(this))
this.mainProductForm.addEventListener('productAdded',this.onSubmitSuccess.bind(this))
this.setContent()})}
handleScroll(){this.headerHeight=Number(getComputedStyle(document.documentElement).getPropertyValue('--hh-total-header-height').replace('px','')||0)
const mainATC=document.querySelector('hh-product-form .product-form__buttons')
const variantPicker=document.querySelector(`[data-id="${this.sectionId}"] hh-variant-picker`)
const mainATCRect=mainATC.getBoundingClientRect()
const mainATCVisible=(mainATCRect.top>=0&&mainATCRect.bottom<=((window.innerHeight||document.documentElement.clientHeight))&&mainATCRect.bottom>=this.headerHeight)
if(!!variantPicker){const pickerRect=variantPicker.getBoundingClientRect();const pickerVisible=(pickerRect.top>=0&&pickerRect.bottom<=(window.innerHeight||document.documentElement.clientHeight))
this._show=!mainATCVisible&&!pickerVisible}else{this._show=!mainATCVisible}}
async onVariantDropdownKeydown(e){const keyOptions=['ArrowDown','ArrowUp','Enter','Space']
if(keyOptions.includes(e.code)){e.preventDefault()
this._open=!this._open
await this.updateComplete
if(this._open){this.variantOptions[0].focus()}}}
onVariantOptionKeydown(e){const keyOptions=['ArrowDown','ArrowUp']
if(keyOptions.includes(e.code)){e.preventDefault()
const currentOption=e.target
const currentIndex=Array.from(this.variantOptions).indexOf(currentOption)
const nextIndex=e.code==='ArrowDown'?currentIndex+1:currentIndex-1
const nextOption=this.variantOptions[nextIndex]
nextOption&&nextOption.focus()}
if(e.code==='Enter'||e.code==='Space'){if(e.code==='Space'){e.preventDefault()
e.target.click()}
this._open=!1
setTimeout(()=>{this.variantPicker.focus()},100)}}
onEscapeKeydown(e){if(!this._open)return!0
if(e.code==='Escape'){this._open=!1
this.variantPicker.focus()}}
onBodyClick(e){const path=e.composedPath()
if(path.some((node)=>node===this)){return!0}
this._open&&(this._open=!1)}
onVariantOptionClick(e){const{value}=e.currentTarget.dataset
this.mainVariantPicker.querySelector(`[value="${value}"]`).click()}
setContent(){if(this._externalButtonContent){return}
if(!this.currentVariant){this.buttonContent=''}else if(this.currentVariant.available){this.buttonContent=`${window.variantStrings.addToCart} - ${HH.formatMoney(
        this.currentVariant.price,
        window.shopSettings.money_with_currency_format
      )}`}else{this.buttonContent=window.variantStrings.notify}}
imageTemplate(){let featuredImage=this.currentVariant?.featured_image
if(!featuredImage){featuredImage=this.defaultMedia?.preview_image}
if(!featuredImage)return''
return html`
      <div class="image-wrapper">
        <img
          class="image"
          src="${featuredImage.src}&width=240"
          alt=${featuredImage.alt}
          width=${featuredImage.width}
          height=${featuredImage.height}
          loading="lazy"
        />
      </div>
    `}
get atcButton(){return this.shadowRoot.querySelector('.add-to-cart')??null}
get variantPicker(){return this.shadowRoot.querySelector('.variant-picker')??null}
get variantOptions(){return this.shadowRoot.querySelectorAll('.variant-option')??null}
get currentVariantIndex(){return(Array.from(this.variantOptions).findIndex((option)=>option.dataset.value===this.currentVariant?.title)+1)}
render(){return html`
      <section
        class=${classMap({
      container: true,
      show: this._show,
      hideOpacity: this.hideOpacity,
    })}
      >
        <div class="wrapper">
          ${this.imageTemplate()}
          <div class="top">
            <span class="h2 product-title">${this.title}</span>
            <span
              class=${classMap({
      'variant-title': true,
      hide: this.hasOnlyDefaultVariant,
    })}
              >${this.currentVariant?.title}</span
            >
          </div>
          <div class="bottom">
            <button
              @click=${this.onVariantDropdownClick}
              @keydown=${this.onVariantDropdownKeydown}
              class=${classMap({
      'variant-picker': true,
      hide: this.hasOnlyDefaultVariant,
    })}
              aria-expanded=${this._open ? 'true' : 'false'}
              aria-controls="variant-options"
            >
              ${this.currentVariant?.title}
              <span
                class=${classMap({
      icon: true,
      active: this._open,
    })}
                >${unsafeHTML(paths.chevron)}</span
              >
            </button>
            <hh-button
              class="add-to-cart"
              theme="primary"
              width="full"
              @click=${this.onAddToCartClick}
            >
              ${this.buttonContent}
            </hh-button>
          </div>
          <ul
            id="variant-options"
            class="${classMap({
      'variant-options': true,
      open: this._open,
    })}"
            role="listbox"
            aria-activedescendant="variant-option-${this.currentVariantIndex}"
          >
            ${this.sizes.map((size, idx) => {
      return html`<li
class="variant-option-list-item"
role="option"
aria-selected=${this.currentVariant?.title===size}
id="variant-option-${idx + 1}"><button
class=${classMap({'variant-option':!0,})}
@click=${this.onVariantOptionClick}
@keydown=${this.onVariantOptionKeydown}
data-value=${size}>${size}<span
class=${classMap({ellipsis:!0,active:this.currentVariant?.title===size,})}>${unsafeHTML(paths.ellipsis)}</span></button></li>`
    })}
          </ul>
        </div>
      </section>
    `}
static styles=css`
    :host *,
    :host *::before,
    :host *::after {
      box-sizing: border-box;
    }

    :host([desktop-only]) {
      display: none;
    }

    :host([mobile-only]) {
      display: block;
    }

    @media (min-width: 992px) {
      :host([desktop-only]) {
        display: block;
      }

      :host([mobile-only]) {
        display: none;
      }
    }

    .container {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      z-index: 3;
      background: var(--hh-color-day);
      transform: translate3d(0, 100%, 0);
      transition: transform var(--hh-duration-long) ease;
      will-change: transform;
    }

    .container.hideOpacity {
      opacity: 0;
      visibility: hidden;
    }

    @media (min-width: 992px) {
      .container {
        width: 39.3750rem;
        left: auto;
        right: 1.2500rem;
        bottom: 7.5000rem;
        transform: translate3d(calc(100% + 1.2500rem), 0, 0);
      }
    }

    .container.show {
      transform: translate3d(0, 0, 0);
    }

    .wrapper {
      position: relative;
      padding: 0.9375rem 0.6250rem;
    }

    @media (min-width: 750px) {
      .wrapper {
        display: flex;
        align-items: center;
        padding: 0;
        column-gap: 1.2500rem;
        min-height: 5.4375rem;
        border: 1px solid var(--hh-color-brand-tertiary);
      }
    }

    .image-wrapper {
      display: none;
    }

    @media (min-width: 750px) {
      .image-wrapper {
        display: block;
        width: 5.0625rem;
        height: 5.4375rem;
        flex-shrink: 0;
        margin: -1px;
      }
    }

    .image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .top {
      display: flex;
      justify-content: space-between;
    }

    @media (min-width: 750px) {
      .top {
        flex-direction: column;
        width: 50%;
      }
    }

    .bottom {
      display: flex;
      column-gap: 0.6250rem;
      margin: 0.6250rem 0 0;
    }

    @media (min-width: 750px) {
      .bottom {
        margin: 0 1.2500rem 0 auto;
        width: 100%;
      }
    }

    .product-title {
      margin: 0;
      font: var(--hh-h-small-font);
    }

    .variant-title {
      font: var(--hh-body-font);
    }

    @media (min-width: 750px) {
      .variant-title {
        font: var(--hh-body-small-font);
      }
    }

    .variant-picker {
      appearance: none;
      position: relative;
      padding: 0.6250rem 0.8750rem;
      color: var(--hh-color-text);
      background-color: var(--hh-color-day);
      border: 1px solid var(--hh-color-neutral);
      min-width: 7.5000rem;
      text-align: left;
      font: var(--hh-body-font);
      cursor: pointer;
    }

    .variant-picker:focus-visible,
    .variant-option:focus-visible {
      outline: 0.1250rem solid var(--hh-color-focus);
      outline-offset: -0.1250rem;
    }

    @media (min-width: 750px) {
      .variant-picker {
        min-width: 6.8750rem;
        font: var(--hh-body-small-font);
      }
    }

    .icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.8750rem;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform var(--hh-duration-default) ease;
    }

    .icon.active {
      transform: translateY(-50%) rotate(180deg);
    }

    .add-to-cart {
      width: 100%;
      --hh-padding: 0.6250rem 1.1250rem;
      --hh-font: var(--hh-button-font);
      --hh-border-bottom-offset: 0;
      --hh-max-width: none;
    }

    .variant-options,
    .container:not(.show) .variant-options {
      display: none;
      position: absolute;
      bottom: 100%;
      left: 0;
      width: 100%;
      padding: 0;
      margin: 0;
      max-height: calc(100vh - var(--hh-total-header-height) - 0.6250rem);
      overflow-y: auto;
    }

    .variant-options.open {
      display: block;
    }

    @media (min-width: 750px) {
      .variant-options {
        width: 12.5000rem;
        left: auto;
        right: 9.6875rem;
      }
    }

    .variant-option-list-item {
      list-style: none;
    }

    .variant-option {
      display: block;
      width: 100%;
      appearance: none;
      padding: 0.6250rem 1.2500rem;
      font: var(--hh-body-font);
      color: var(--hh-color-text);
      background-color: var(--hh-color-day);
      border: 1px solid var(--hh-color-brand-tertiary);
      text-align: left;
      border-bottom: none;
      cursor: pointer;
      position: relative;
    }

    .variant-option:last-child {
      border-bottom: 1px solid var(--hh-color-brand-tertiary);
    }

    .ellipsis {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.1250rem;
      display: none;
      pointer-events: none;
      color: var(--hh-color-night);
    }

    .ellipsis.active {
      display: flex;
    }

    .hide {
      display: none;
    }
  `}
customElements.define('hh-sticky-atc',HHStickyAtc)